<template>
    <div class="ppv2-flex ppv2-items-center ppv2-justify-between ppv2-px-5 ppv2-pt-4 ppv2-pb-3">
        <PreviewLabel />
        <LiveBadge />
    </div>
</template>

<script>
import PreviewLabel from './PreviewLabel.vue'
import LiveBadge from './LiveBadge.vue'

export default {
    name: 'PreviewHeader',
    components: {
        PreviewLabel,
        LiveBadge,
    },
}
</script>
